import React from "react";
import { Camera } from "lucide-react";
import { company } from "../../data/mock";


export const TextQuoteButton = ({ label, testId, dark = false, className = "", href = company.photoSms }) => (
  <a
    href={href}
    data-testid={testId}
    className={`group inline-flex items-center justify-center gap-3 px-7 py-4 rounded-full font-bold text-base md:text-lg transition-[transform,background-color] duration-200 hover:-translate-y-0.5 ${
      dark ? "bg-[#0a1f44] hover:bg-[#123a7a] text-white" : "bg-[#3b9dff] hover:bg-[#2b8ae8] text-white shadow-lg shadow-[#3b9dff]/30"
    } ${className}`}
  >
    <Camera className="w-5 h-5 shrink-0" />
    <span>{label || `Text a photo of your room for a quote, ${company.phone}.`}</span>
  </a>
);
